
import { useEffect } from "react";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import Header from "@/components/Header";
import FooterSection from "@/components/FooterSection";
import DiscoverySessionForm from "@/components/forms/DiscoverySessionForm";
import SectionHeader from "@/components/common/SectionHeader";

const FreeDiscoverySession = () => {
  useScrollToTop();

  useEffect(() => {
    document.title = "Free AI Discovery Session | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Free AI discovery session for law firms. Expert consultation, needs assessment & strategic recommendations. Book your call.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Free AI discovery session for law firms. Expert consultation, needs assessment & strategic recommendations. Book your call.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      
      <main className="flex-1">
        <section className="relative px-6 pt-24 pb-20 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
          
          <div className="container mx-auto max-w-4xl relative z-10">
            <SectionHeader
              highlightedText="Free"
              title="Discovery Session"
              description="Schedule a no-obligation consultation with our AI strategy experts. We'll help you understand how AI can transform your practice and create a roadmap for success."
              centered={true}
            />
            
            <div className="mt-12">
              <DiscoverySessionForm />
            </div>
          </div>
        </section>
      </main>
      
      <FooterSection />
    </div>
  );
};

export default FreeDiscoverySession;
